module.exports = __webpack_public_path__ + "img/Checkmark-green.261dd21d.svg";